import Index from "./src/Index";
export default Index;
